import { render, staticRenderFns } from "./bofangChaternew.vue?vue&type=template&id=6fe11896&scoped=true"
import script from "./bofangChaternew.vue?vue&type=script&lang=js"
export * from "./bofangChaternew.vue?vue&type=script&lang=js"
import style0 from "./bofangChaternew.vue?vue&type=style&index=0&id=6fe11896&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe11896",
  null
  
)

export default component.exports